/** @jsx jsx */
import { Box, Flex } from "@eworkit/iris";
import React, { FC } from "react";
import { jsx } from "theme-ui";

interface FullScreenModalFloatingActionsProps {}

export const FullScreenModalFloatingActions: FC<FullScreenModalFloatingActionsProps> = ({ children }) => {
  return (
    <React.Fragment>
      <Box sx={{ height: 120 }} />

      <Flex
        sx={{
          position: ["relative", null, "fixed"],
          bottom: [null, null, 24],
          left: [null, null, 0],
          right: [null, null, 0],
        }}
        justifyContent={[null, null, "center"]}>
        <Flex
          sx={{
            boxShadow: [null, null, "lg"],
          }}
          px={["sm", null, "md"]}
          py="sm"
          flexGrow={[1, null, 0]}
          flexDirection={["column-reverse", null, "row"]}
          justifyContent={[null, null, "center"]}
          gap={["xs", null, "sm"]}
          backgroundColor="n0"
          borderRadius="lg">
          {children}
        </Flex>
      </Flex>
    </React.Fragment>
  );
};
